const useVersionCheck = () => {
  const checkVersion = async (version: string) => {
    const localVersion = localStorage.getItem('app_version');

    if (!localVersion) {
      localStorage.setItem('app_version', version);
    } else if (localVersion !== version) {
      localStorage.setItem('app_version', version);
      window.location.reload();
    }
  };

  return { checkVersion };
};

export default useVersionCheck;
